var _defs, _path, _ellipse, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVarunaIconsDisinfectant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.769,
    height: 33.769,
    viewBox: "0 0 33.769 33.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c0c0c1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.67,150.31a1.31,1.31,0,1,0-1.31-1.31A1.311,1.311,0,0,0,184.67,150.31Z",
    transform: "translate(-168.877 -126.626)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.841,
    cy: 0.841,
    rx: 0.841,
    ry: 0.841,
    transform: "translate(18.078 24.255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.8,108.61H159.945a3.459,3.459,0,0,0-3.455,3.455v26.859a3.459,3.459,0,0,0,3.455,3.455H186.8a3.459,3.459,0,0,0,3.455-3.455V112.065A3.462,3.462,0,0,0,186.8,108.61Zm-4.048,28.562a2.981,2.981,0,0,1-2.738,1.391c-1.471,0-3.714-.032-6.091-.065-2.49-.032-5.061-.07-6.829-.07a3.285,3.285,0,0,1-3.148-1.471c-.749-1.315-.264-3.062.447-4.253.97-1.639,4.538-8.128,5.148-9.239V115a.712.712,0,0,1-.668-.706.72.72,0,0,1,.717-.717h7.535a.717.717,0,1,1,0,1.434H176.9v8.177c.668,1.2,4.835,8.727,5.7,10.263A3.832,3.832,0,0,1,182.756,137.172Z",
    transform: "translate(-156.49 -108.61)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M178.265,129.308l-.086.162c-.172.313-4.188,7.632-5.261,9.438a3.137,3.137,0,0,0-.431,2.814c.28.5.922.744,1.9.744,1.773,0,4.355.038,6.845.07,2.372.032,4.609.065,6.069.065a1.6,1.6,0,0,0,1.5-.679,2.434,2.434,0,0,0-.178-2.291c-.932-1.666-5.74-10.344-5.789-10.43l-.092-.162V120.49h-4.485v8.818Zm5.827,4.4,3.9,6.862a.675.675,0,0,1-.016.717.719.719,0,0,1-.62.356H173.9a.716.716,0,0,1-.625-1.062l3.768-6.862a.717.717,0,0,1,.631-.372h5.789A.715.715,0,0,1,184.092,133.706Zm-2.49-3.795a1.31,1.31,0,1,1-1.31,1.31A1.311,1.311,0,0,1,181.6,129.912Z",
    transform: "translate(-163.777 -114.087)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarunaIconsDisinfectant);
export default __webpack_public_path__ + "static/media/Varuna_Icons_disinfectant.40a9d904.svg";
export { ForwardRef as ReactComponent };